import { LockStatus } from '../useConcurrentialAccess';

export const notifyByMail = (lockStatus: LockStatus, unlockLink: string) => {
  const { lockedBy } = lockStatus;
  if (!lockedBy || !lockedBy.email) return;

  const formatUrl = (text: string) =>
    text.trim().replace(/\r/g, '%20').replace(/\n/g, '%0A');

  const mailBody = formatUrl(`
Bonjour,

Ce mail est généré automatiquement. Il vous est adressé car je souhaite accéder à l'édition d'une page que vous avez verrouillée.

Pourriez-vous libérer l'édition de cette page en cliquant sur ce lien ?
${unlockLink}

Cordialement
`);

  const mailSubject = formatUrl(`Demande d'accès à une page vérrouillée`);

  window.open(
    `https://mail.google.com/mail/u/0/?fs=1&to=${lockedBy.email}&tf=cm&body=${mailBody}&su=${mailSubject}`,
  );
};
